import React, { useEffect, useState } from 'react';
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from 'classnames';
import ContactDetails from './KysOneTabs/ContactDetails/ContactDetails';
import BusinessDetails from './KysOneTabs/BusinessDetails/BusinessDetails';
import TaxationStatutory from './KysOneTabs/TaxationStatutory/TaxationStatutory';
import BankDetails from './KysOneTabs/BankDetails/BankDetails';


const KysOne = ({viewDataFromSupplier}) => {
  const [activeTab, setActiveTab] = useState('1');
  const [vendorKys1Data, setVendorKys1Data] = useState(null);

  const toggleKys1FormTabs = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <div>
      <div className="time-line-download-wrap hl-assessment-accordian hl-self-assessment-wrap">
        <Row className=''>
          <Col lg='12'>
            {/* <div className="hl-accordian-wrap pt-4"> */}
            {/* <h3 className='mt-2 mb-2'>Registration Form</h3>
              <label>(The information populated is this form is taken from your submitted application.)</label> */}
            <h3 className='my-4 fw-normal'>
              <small className='hl-status-update'>
                <strong>Supplying to which plants of Havells:</strong> {vendorKys1Data?.BankDetails?.GeneralDetailsOfVendor?.SupplyingPlantName || "N/A"}
              </small>
            </h3>
            <div className="hl-assessment-tab-section mt-4">
              <Nav tabs className="subtabs mt-0 p-relative">
                <NavItem>
                  <NavLink id={`dashboard_Masters_Pending_Approval`} className={classnames({ active: activeTab === '1' })}
                  // onClick={() => { toggleKys1FormTabs('1'); }}
                  >
                    Contact Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '2' })}
                  // onClick={() => { toggleKys1FormTabs('2'); }}
                  >
                    Business Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '3' })}
                  // onClick={() => { toggleKys1FormTabs('3'); }}
                  >
                    Taxation Statutory
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink id={`dashboard_Masters_Awaiting_Approval`} className={classnames({ active: activeTab === '4' })}
                  // onClick={() => { toggleKys1FormTabs('4'); }}
                  >
                    Bank Details
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="hl-tab-content-section">
                {activeTab === '1' &&
                  <TabPane tabId="1" className="pt-4">
                    <ContactDetails
                      // supplierDetail={supplierDetail} 
                      setVendorKys1Data={setVendorKys1Data}
                      toggleKys1FormTabs={toggleKys1FormTabs} />
                  </TabPane>}

                {activeTab === '2' &&
                  <TabPane tabId="2" className="pt-4">
                    <BusinessDetails
                    viewDataFromSupplier={viewDataFromSupplier}
                      // supplierDetail={supplierDetail} 
                      toggleKys1FormTabs={toggleKys1FormTabs} />
                  </TabPane>}

                {activeTab === '3' &&
                  <TabPane tabId="3" className="pt-4">
                    <TaxationStatutory
                      // supplierDetail={supplierDetail} 
                      toggleKys1FormTabs={toggleKys1FormTabs} />
                  </TabPane>}

                {activeTab === '4' &&
                  <TabPane tabId="4" className="pt-4">
                    <BankDetails
                    viewDataFromSupplier={viewDataFromSupplier}
                      // supplierDetail={supplierDetail} 
                      toggleKys1FormTabs={toggleKys1FormTabs} />
                  </TabPane>}
              </TabContent>
            </div>
            {/* </div> */}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default KysOne;
